import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";

export default function AnimatedMetrics() {

  const metricSets = [
    ["GAD-7", "PHQ-9", "Side-effects", "Resting HR trends"],
    ["Sleep quality", "Stress episodes", "Circadian shifts"],
    ["EHR Integration", "HR variability", "Sleep fragmentation"]
  ];

  const [setIndex, setSetIndex] = useState(0);
  const currentSet = metricSets[setIndex];

  return (
    <Box
      sx={{
        width: "100%",
        mt: 2,
        textAlign: { xs: "center", md: "left" }  // center ONLY on mobile
      }}
    >

      {/* Metric Labels */}
      <Box
        sx={{
          display: "flex",
          justifyContent: { xs: "center", md: "flex-start" },
          px: 0,
          ml: 0,
        }}
      >
        <AnimatePresence mode="wait">
          <motion.div
            key={setIndex}
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -6 }}
            transition={{ duration: 0.35 }}
          >
            <Typography
              variant="overline"
              sx={{
                textTransform: "uppercase",
                letterSpacing: "1.4px",
                color: "#6366f1",
                fontWeight: 600,
                opacity: 0.9,
                fontSize: { xs: "0.72rem", sm: "0.78rem" },
                mb: 1.5,
                display: "inline-block",
              }}
            >
              {currentSet.map((m, i) => (
                <span
                  key={i}
                  style={{ display: "inline-flex", alignItems: "center" }}
                >
                  {m}
                  {i !== currentSet.length - 1 && (
                    <span
                      style={{
                        width: 6,
                        height: 6,
                        borderRadius: "50%",
                        background: "rgba(90, 90, 160, 0.35)",
                        marginLeft: 10,
                        marginRight: 10,
                      }}
                    />
                  )}
                </span>
              ))}
            </Typography>
          </motion.div>
        </AnimatePresence>
      </Box>

      {/* Dot Controls */}
      <Box
        sx={{
          display: "flex",
          justifyContent: { xs: "center", md: "flex-start" },
          gap: 1.2,
          mt: 0.5,
        }}
      >
        {metricSets.map((_, i) => (
          <Box
            key={i}
            onClick={() => setSetIndex(i)}
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              cursor: "pointer",
              transition: "0.25s",
              background:
                i === setIndex
                  ? "rgba(99, 102, 241, 0.9)"
                  : "rgba(99, 102, 241, 0.35)",
            }}
          />
        ))}
      </Box>
    </Box>
  );
}
